module.exports = {
  namespaced: true,
  state: {
    customerId: null,
    specialistId: null,
    remoteUser: {
      id: null,
      name: null,
      avatar: null,
    },
  },
  getters: {
    userAuth: (state, getters, rootState, rootGetters) => rootGetters['auth/userAuth'],
    customerId: (state, getters) => {
      if (getters.userAuth.role === 'customer') {
        return getters.userAuth.authenticatedUser
      }
      if (getters.userAuth.role === 'specialist') {
        return state.remoteUser.id
      }
    },
    specialistId: (state, getters) => {
      if (getters.userAuth.role === 'specialist') {
        return getters.userAuth.authenticatedUser
      }
      if (getters.userAuth.role === 'customer') {
        return state.remoteUser.id
      }
    },
    remoteUser: state => state.remoteUser,
    refPath(state, getters) {
      return `/chats/${getters.specialistId}_${getters.customerId}`
    },
    refMessagePath(state, getters) {
      return `${getters.refPath}/messages`
    },
    refChatCustomerNotRead(state, getters) {
      return `${getters.refPath}/customer_not_read`
    },
    refCustomerNotRead(state, getters) {
      return `/customer_not_read/${getters.customerId}`
    },
    refChatSpecialistNotRead(state, getters) {
      return `${getters.refPath}/specialist_not_read`
    },
    refSpecialistNotRead(state, getters) {
      return `/specialist_not_read/${getters.specialistId}`
    },
  },
  mutations: {
    setRemoteUser(state, remoteUser) {
      state.remoteUser = remoteUser
    },
  },
  actions: {

  },
  modules: {

  },
  plugins: [

  ],

}
